import { AxiosResponse } from "axios";
import IHttpGetServiceProps from "./IHttpGetServiceProps";
import { instance } from 'Services/instance'
import { downloadFile } from "Utils/downloadFile";
import TrimJson from "Utils/TrimJson";

const HttpGetService = async (props: IHttpGetServiceProps) => {
    if (props.onResult === undefined) {
        props.onResult = (res: AxiosResponse<any, any>): any => {
            if (res.status === 200 && props.isFile) {
                const fileType = res.headers['content-type'];
                const fileName = res.headers['content-disposition']?.split("''")[1] ?? '';

                downloadFile(res.data, decodeURIComponent(fileName), fileType);
            }
            if (res.status === 200) {
                return res.data
            }
        };
    }
    if (props.onError === undefined) {
        props.onError = (error: any) => {
            console.error(error);
        }
    }

    try {
        const params = TrimJson(props.params)
        const response = await instance.get(props.url, { responseType: props.responseType, timeout: 60000, params: params })
            .then(props.onResult)
            .catch(props.onError)
        return response
    } catch (error) {
        console.error(error);
    }
}

export default HttpGetService;